import { Badge, notification } from 'antd';
import { TablePull } from 'features/tables';
import React, { useEffect, useState } from 'react';
import { SortCondition } from 'shared/enums';
import { dataForAbsenceSupervisorTable, sortingDate } from 'shared/helpers/utils';
import { usePullSort } from 'shared/hooks';
import { RequestsSearch, TColumns } from 'shared/types/types';
import { useAppSelector } from 'app/store';

import { SearchKeysNews } from 'shared/enums/news';
import ModalAbsenceSubordinates from 'features/absence/modalAbsenceSubordinates';
import { getAbsenceSupervisor } from 'entities/supervisor/absence';
import { getCurrentDivision } from 'entities/divisions/model';
import { absenceSupervisorApi, TPreparedAbsenceSupervisor } from 'app/services/edpApiV1/supervisor/absenceSupervisor';
import { TabKeys } from 'features/divisions';
import { returnErrorOrMessage } from 'shared/helpers/errors';
import { AbsenceModal } from '../absenceModal';

const AbsenceSubordinatesPull = () => {
  const [page, setCurrentPage] = useState<number>(1);
  const [size, setCurrentSize] = useState<number>(10);
  const [requestId, setRequestId] = useState<number>();
  const [openModal, setOpenModal] = useState(false);
  const [currentAbsence, setCurrentAbsence] = useState<TPreparedAbsenceSupervisor | undefined>();
  const [sortInfo, trigger] = usePullSort();
  const [search, setSearch] = useState<RequestsSearch>({ byId: undefined, fio: undefined });

  const { currentOption } = useAppSelector(getCurrentDivision);
  const { data, pagination, loading, success, error } = useAppSelector(getAbsenceSupervisor);

  const [getAbsencesDeputy] = absenceSupervisorApi.useLazyGetAllAbsenceDeputyQuery();
  const [getAbsencesActing] = absenceSupervisorApi.useLazyGetAllAbsenceActingQuery();
  const [getAbsencesSupervisor] = absenceSupervisorApi.useLazyGetAllAbsenceSupervisorQuery();

  const refetch = () => {
    if (!currentOption) {
      return;
    }
    try {
      switch (currentOption.type) {
        case TabKeys.ACTING:
          getAbsencesActing({ page, size, divisionId: currentOption.value, ...search });
          break;
        case TabKeys.DEPUTY:
          getAbsencesDeputy({ page, size, divisionId: currentOption.value, ...search });
          break;
        case TabKeys.SUPERVISOR:
          getAbsencesSupervisor({ page, size, ...search });
          break;
      }
    } catch (e: any) {
      notification.error({ message: returnErrorOrMessage(e, 'Не удалось получить неявки') });
    }
  };

  useEffect(() => {
    refetch();
  }, [currentOption, search]);

  const onSearch = (data: string, key: SearchKeysNews) => {
    if (key === SearchKeysNews.SEARCH_ID) {
      setSearch({ fio: undefined, byId: data ? data : undefined });
    } else if (key === SearchKeysNews.SEARCH_NAME) {
      setSearch({ byId: undefined, fio: data ? data : undefined });
    } else {
      setSearch({ [key]: data ? data : undefined });
    }
  };

  const handleToWork = (key: React.Key) => {};

  const onRowClick = (data: unknown) => {
    setCurrentAbsence(data as TPreparedAbsenceSupervisor);
    setOpenModal(true);
  };

  const columns: TColumns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'key',
      width: 120,
    },
    {
      title: 'Дата',
      dataIndex: 'created',
      key: 'created',
      sortDirections: [SortCondition.ASCEND, SortCondition.DESCEND],
      sorter: (a, b) => sortingDate(a.created, b.created),
      onHeaderCell: _ => ({
        onClick: () => trigger(),
      }),
    },
    {
      title: 'Период',
      dataIndex: 'period',
      key: 'period',
    },
    {
      title: 'ФИО',
      dataIndex: 'fio',
      key: 'fio',
    },
    {
      title: 'Статус',
      dataIndex: 'status',
      key: 'status',
      render: status => (
        <span>
          <Badge status={status.type} />
          {status.name}
        </span>
      ),
    },
  ];

  return (
    <>
      {data && (
        <>
          <TablePull
            dataSource={dataForAbsenceSupervisorTable(data)}
            columns={columns}
            currentPage={page}
            setCurrentPage={setCurrentPage}
            total={pagination?.total}
            setCurrentSize={setCurrentSize}
            currentSize={size}
            onSearch={onSearch}
            onRowClick={onRowClick}
          />
          <AbsenceModal
            openModal={openModal}
            setOpenModal={setOpenModal}
            id={'absence-modal'}
            absence={currentAbsence}
          />
        </>
      )}
      {requestId && (
        <ModalAbsenceSubordinates openModal={openModal} setOpenModal={setOpenModal} requestId={requestId} />
      )}
    </>
  );
};

export default AbsenceSubordinatesPull;
